/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect } from "react";

const useClickAway = (ref, clickAwayHandler) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                // alert("You clicked outside of me!");
                clickAwayHandler(event);
            }
        };
        document.addEventListener(
            "mousedown",
            handleClickOutside
        );
        return () => {
            document.removeEventListener(
                "mousedown",
                handleClickOutside
            );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);
};

export { useClickAway };

// --- How to use -------
// export default function ToolTipLayer(props) {
//     const wrapperRef = useRef(null);
//     useClickAway(wrapperRef);
//     return <div ref={wrapperRef}>{props.children}</div>;
// }
